<template>
<div class="user-head-wrapper">

  <el-dropdown v-if="userinfo.isLogin">

    <span class="el-dropdown-link">
      <span class="welcome">欢迎：{{userinfo.name}}(手机:{{userinfo.phone}})</span>
      <el-avatar :size="50" :src="userinfo.avatar" fit="fit" class="user-avatar"/>
      <i class="el-icon-arrow-down el-icon--right"></i>
      <el-image v-if="userinfo.isVip" :src="vipUrl" fit="fit" class="vip" />
    </span>

    <el-dropdown-menu slot="dropdown" >
      <el-dropdown-item icon="el-icon-setting" @click.native="onUserinfo">我的资料</el-dropdown-item>
      <el-dropdown-item icon="el-icon-user-solid" @click.native="onMyJob">职业倾向</el-dropdown-item>
      <el-dropdown-item icon="el-icon-star-off" @click.native="onMyFavoriteInformation">我的收藏</el-dropdown-item>
      <el-dropdown-item icon="el-icon-question" @click.native="onMyQuestion">我的提问</el-dropdown-item>
      <el-dropdown-item icon="el-icon-s-order" @click.native="onMyFavoriteCollege">我的志愿</el-dropdown-item>
      <el-dropdown-item icon="el-icon-back" @click.native="onLogout">退出登陆</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
  <el-button round v-else @click="login" class="user-login-button">登陆</el-button>

</div>
</template>

<script type="text/ecmascript-6">
import {mapState} from 'vuex'

export default {
  name: 'Userhead',
  data () {
    return {
      vipUrl: require('@img/vip.png'),
      myJobUrl: ''
    }
  },
  computed: {
    ...mapState({
      userinfo: 'userinfo',
    })
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData(){
      const that = this
      let params = {
        entryname: '职业倾向',
      }
      that.axios.get('/homepage/entry/findbyname', {params})
      .then(res =>{
        let {code, message}=res;
        if(code==0){
          that.myJobUrl=res.data;
        }else{
          that.$message(message)
        }
      })
    },
    onUserinfo(){
      this.$router.push({ path: '/userinfo' })
    },
    onLogout(){
      this.$store.commit('logout')
    },
    onMyFavoriteCollege(){
      this.$router.push({ path: '/myfavoritecollege' })
    },
    onMyFavoriteInformation(){
      this.$router.push({ path: '/myfavoriteinformation' })
    },
    onMyQuestion(){
      this.$router.push({ path: '/myquestion' })
    },
    onMyJob(){
      //新页面方式打开客服
      window.open(this.myJobUrl, "_blank")
    },
    login(){
      this.$router.push({ path: '/login' })
    }
  }
}
</script>

<style lang="stylus" scoped>
.user-head-wrapper
  .welcome
    display: inline-block
    line-height 100px
    vertical-align: top
    margin-right: 20px
  .user-avatar
    margin-top: 20px
  .vip
    position: absolute
    top: 10px
    right:10px
    width: 25px
    height: 25px
  .user-login-button
    margin-top: 30px
</style>
